var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnLinePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4637 3.87211C7.86317 2.65426 9.17428 1.99083 10.3921 2.3903L14.932 3.87945C16.1499 4.27892 16.8133 5.59003 16.4139 6.80788L14.7616 11.845C14.3621 13.0629 13.051 13.7263 11.8332 13.3268L7.29326 11.8377C6.07541 11.4382 5.41198 10.1271 5.81145 8.90925L7.4637 3.87211Z",
    fill: "#6DF0DE"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.64144,
    y: 0.0255551,
    width: 22.2829,
    height: 21.2829
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.32px)",
      clipPath: "url(#bgblur_0_12563_8006_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12563_8006)",
    "data-figma-bg-blur-radius": 4.64144
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.14807C0 6.22552 1.55853 4.66699 3.48108 4.66699H9.51892C11.4415 4.66699 13 6.22552 13 8.14807V13.1859C13 15.1085 11.4415 16.667 9.51892 16.667H3.48108C1.55853 16.667 0 15.1085 0 13.1859V8.14807Z",
    fill: "#3FD7DA",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.53874,
    y: 5.20573,
    width: 9.92252,
    height: 8.92252
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.23px)",
      clipPath: "url(#bgblur_1_12563_8006_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.46126,
    d: "M8.16992 7.83594C8.3562 7.63247 8.65747 7.63247 8.84375 7.83594C9.03057 8.0402 9.03057 8.37191 8.84375 8.57617L6.16797 11.498C6.07466 11.6 5.95269 11.6504 5.83105 11.6504C5.70946 11.6504 5.58742 11.5999 5.49414 11.498L4.15625 10.0371C3.96953 9.83287 3.96957 9.50146 4.15625 9.29785C4.34256 9.09435 4.64382 9.09343 4.83008 9.29688L5.81934 10.3779L5.83105 10.3906L5.84375 10.3779L8.16992 7.83594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0328168
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12563_8006",
    x: -4.64144,
    y: 0.0255551,
    width: 22.2829,
    height: 21.2829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.232072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16036
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12563_8006"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_12563_8006_clip_path",
    transform: "translate(4.64144 -0.0255551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.14807C0 6.22552 1.55853 4.66699 3.48108 4.66699H9.51892C11.4415 4.66699 13 6.22552 13 8.14807V13.1859C13 15.1085 11.4415 16.667 9.51892 16.667H3.48108C1.55853 16.667 0 15.1085 0 13.1859V8.14807Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_12563_8006_clip_path",
    transform: "translate(-1.53874 -5.20573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16992 7.83594C8.3562 7.63247 8.65747 7.63247 8.84375 7.83594C9.03057 8.0402 9.03057 8.37191 8.84375 8.57617L6.16797 11.498C6.07466 11.6 5.95269 11.6504 5.83105 11.6504C5.70946 11.6504 5.58742 11.5999 5.49414 11.498L4.15625 10.0371C3.96953 9.83287 3.96957 9.50146 4.15625 9.29785C4.34256 9.09435 4.64382 9.09343 4.83008 9.29688L5.81934 10.3779L5.83105 10.3906L5.84375 10.3779L8.16992 7.83594Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnLinePayment);
export default __webpack_public_path__ + "static/media/onLinePayment.2295e7da77d31afd5399d04999855f05.svg";
export { ForwardRef as ReactComponent };